"use client";
// Client Component: TanStack Query and NextAuth SessionProvider both need
// a React context rooted in the client tree.

import { useState, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { SessionProvider } from "next-auth/react";
import { makeQueryClient } from "@/lib/query-client";

type ProvidersProps = {
  children: ReactNode;
};

export function Providers({ children }: ProvidersProps) {
  // `useState` guarantees a stable client per render tree; avoids the
  // "shared client across unrelated requests" pitfall on the server.
  const [queryClient] = useState(() => makeQueryClient());

  return (
    <SessionProvider>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </SessionProvider>
  );
}
